/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};
(function ($) {
  'use strict';
  /**
   * Вид формы добавления комментария
   */
  app.ClaimItemResponseCommentFormView = app.ClaimUploadFormView.extend({
    formElement: '.field',
    events: {
      'click .js-close-comment-form': 'closeForm',
      'click .js-send-comment-form': 'validateModel',
      'change .fileupload': 'photoUpload',
      'click .photo-remove': 'removePhoto'
    },

    run: function () {
      app.ClaimUploadFormView.prototype.run.apply(this, arguments);
      this.notLoaded=[];
      this.responseCommentForm = app.helpers.TemplateHelper.getTemplate('#response-comment-form-template');
      this.uploadOptions = _.extend(this.uploadOptions, {
        fileField: 'file_name',
        itemIdField: 'claim_item_response_comment_id',
        urlRoot: '/api/v3/claim-item-response-comment-photo/'
      });
    },
    render: function () {
      var element = $(this.responseCommentForm());
      this.setElement(element);
      this.updateFieldsList();
      return this;
    },

    /**
     *  Скрытие формы
     */
    closeForm: function () {
      delete this.model;
      this.remove();
      this.stopListening();
      this.trigger('claim-item-cancel-form');
    },

    /**
     * Валидация модели
     */
    validateModel: function () {
      this.showError = true;
      this.model.set(this.getData());
      this.save(null);
    },


    saveSuccess: function () {
      this.clearErrors();
      this.model.set('valid', true);
      this.isSaving = false;
      // проверяем, есть ли незагруженные фотки
      if (this.notLoaded.length) {
        var deferred = [],
          loaded = [];
        // сохраняем запросы в массив deferred
        while (this.notLoaded.length) {
          var photoForm = this.notLoaded.shift();
          photoForm.append('claim_item_response_comment_id', this.model.get('id'));
          deferred.push(this.postFormData(photoForm, loaded));
        }
        // после того как все запросы закончатся выполняем рендер
        $.when.apply($, deferred).done(function () {
          var claimItemResponseCommentPhotos = this.model.get('claim_item_response_comment_photos');
          if (!claimItemResponseCommentPhotos) {
            claimItemResponseCommentPhotos = {};
          }
          _.each(loaded, function (photo) {
            claimItemResponseCommentPhotos[photo.id] = photo;
          });
            this.model.set('claim_item_response_comment_photos', claimItemResponseCommentPhotos);
            this.trigger('claim-item-view-saved', this.model);
        });
      } else {
        this.trigger('claim-item-view-saved', this.model);
      }
    },

    saveError: function (model, response) {
      if (this.showError) {
        this.error(model, response);
      }
      this.model.set('valid', false);
      this.isSaving = false;
    },
    /**
     * Сохранение формы
     */
    save: function (key, value) {
      this.isSaving = true;
      var options = {
          success: this.saveSuccess,
          error: this.saveError
        };
      this.$fields = this.$el.find(this.formElement);
      return this.model.save(key, value, options);
    },
    /**
     * Удаление добавленной фотографии.
     * @param e
     */
    removePhoto: function (e) {
      var $parent = $(e.target).parents('.claim-photo-block'),
        allPhotos = this.$('.photo-thumbnails').children(),
        index = allPhotos.index($parent),
        id = $parent.data('photo-id');
      if (!id) {
        this.notLoaded.splice(index, 1);
      }
      $parent.remove();
      // если фотки еще нет на сервере, не нужно отправлять запрос на удаление
      if (id) {
        $.ajax({
          url: '/api/v3/claim-item-response-comment-photo/' + id + '/',
          method: 'DELETE'
        });
      }
    },
    /**
     * заполнение ошибок
     * @param errors
     */
    fillErrors: function (errors) {
      var that = this;
      errors.forEach(function (error) {
        that.$('.' + error.field + '-error').text(error.message);
        that.$('.' + error.field).addClass('error');
      });
    }

  });
})(jQuery);

}.call(window));